module.exports = __webpack_public_path__ + "static/save big-4fe2caeb406737f278b740e7f2a34ee2.svg";